import React from "react";
import { TargetEditor } from "../editors";

/**
 * Profile → Target tab. The targeting configuration — Collection Sync (collection root + "include
 * descendants") or Asset Import (deterministic match key: asset ID / business key / scoped
 * filename).
 */

export default function TargetPanel({ id }: { id: string }) {
  return <TargetEditor id={id} />;
}
